export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Errors.json?hash=24fbdba2eb8912c6c8c47a277ece9b09";